export default __webpack_public_path__ + "static/media/Overpass-Regular.6bb993c6.woff2";